 
import {Shaders} from "../../../../../build/shaders/shaders.js";
import TileTree from './TileTree.js'
import TilePrioritizer from './TilePrioritizer.js'
import TileUtils from './TileUtils' 
import {settings,config} from '../../../settings.js'
/* import config from '../../config' */
import * as THREE from "../../../../../libs/three.js/build/three.module.js"; 
import math from '../../../utils/math.js' 
import browser from '../../../utils/browser.js' 
import Common from '../../../utils/Common.js'
import BasicMaterial from '../../../materials/BasicMaterial.js'  

let {PanoSizeClass, PanoRendererEvents , Vectors,SceneRendererEvents,TileDownloaderEvents, GLCubeFaces} = Potree.defines
 

function createDescriptor() {
    var e = {
        renderTarget: null,
        inUse: !1,
        size: -1,
        pano: null
    };
    return e
}
 

      

/* function upload() { 
    if (!this.uploadIntervalCancelled) {
        if (this.overlayTilesLoaded || !this.usingTileOverlay) {
            b = !0   
            let maxNonBaseUploadsPerFrame = viewer.mainViewport.view.isFlying() ? 1 : this.maxNonBaseUploadsPerFrame //原先2。这是每帧uploadTile非512的瓦片tex的数量。之前的2太卡了，降为1。（检测卡顿方法：在一个pano点旋转至所有2048的tile都加载完，然后之后到这个点看看卡不卡。因为该点tiles都下载完了所以会在飞过来时陆续都加载，所以容易卡）
            this.updateUploadQueue(maxNonBaseUploadsPerFrame, this.maxBaseUploadsPerFrame) 
            let time = viewer.mainViewport.view.isFlying() ? 60 : w  //add 飞行有时候会卡，增长间隔 
            this.peekNextFromUploadQueue() ? this.refreshUploadInterval(time) : this.uploadInterval = null  //定时下一次更新
        } else {
            this.refreshUploadInterval(this.uploadIntervalDelay)
        }
    }
} */

var b = !1,
    w = config.tiling.uploadIntervalDelay,
    _ = config.tiling.initialIntervalDelay,
    T = config.tiling.maxNonBaseUploadsPerFrame,//2   size>512的每次只upload这么多个
    x = config.tiling.maxBaseUploadsPerFrame,//6
    S = {
        Base: 0,
        Remaining: 1
    }/* ,
    M = []; */

class PanoRenderer extends THREE.EventDispatcher{
    constructor(viewer, tileDownloader, qualityManager) {
        super()
		this.tileDirectory = {};
        this.activeRenderTargetDescriptors = {};
        this.activePanos = [];
        this.panoLODDescriptors = {};
        this.panoDescriptors = {};
        this.tileTrees = {};
        this.forceQueue = [];
        this.uploadQueues = {};
        this.uploadInterval = null;
        this.uploadIntervalCancelled = true//!1;
        this.usingTileOverlay = !1;
        this.overlayTilesLoaded = !1;
        this.overlayTileBase = null;
        this.overlayTilesBasic = {};
        this.overlayTilesEnhanced = {};
        this.zoomRenderTarget = null;  //用于缩放的rendertarget  
        this.zoomPano = null;
        this.zoomingActive = !1;
        this.zoomPanoId = null;
        this.zoomPanoRenderingDisabled = !1;
        this.direction = []//new THREE.Vector3;
       
        this.maxBaseUploadsPerFrame = x;
        this.maxNonBaseUploadsPerFrame = T;
                                 
  
		 
        this.M = [];//move M to here  似乎列表里会有两个
        this.viewer = viewer
        
        this.tileDownloader = tileDownloader 
        this.qualityManager = qualityManager  
                                                                                                    
        this.initTime = performance.now()
        this.bindEvents()  
        
        
    }

     
    
    
    getActivePanoTextures(e) {
        e = e || [];
        for (var t = 0; t < M.length; t++) {
            var i = M[t];
            i.renderTarget && i.renderTarget.texture && e.push(i.renderTarget.texture)
        }
    }

    hasQueuedTiles() {
        var e = this.peekNextFromUploadQueue();
        return null !== e && void 0 !== e
    }

    getActiveRenderTargetDescriptor(e) {
        return this.activeRenderTargetDescriptors[e]
    }

    setActiveRenderTargetDescriptor(e, t) { 
        this.activeRenderTargetDescriptors[e] = t
    }

    

    bindEvents() {
        this.tileDownloader.addEventListener(TileDownloaderEvents.TileDownloadSuccess, this.onTileDownloaded.bind(this)) 
    }



    enableUltraHighQualityMode(e) {
        if(config.tileClass == "2k"||config.tileClass == "1k")return this.enableHighQuality(e)//xzw add     濡傛灉鏈€澶氬彧瑕?k鐨勮瘽
        if (!this.qualityManager.ultraHighQualityModeEnabled()) {
            var t = this.qualityManager.getPanoSize(PanoSizeClass.ULTRAHIGH);
            this.tileDownloader.testDownload(t, TileUtils.TILE_SIZE, function (t) {
                     t && (this.qualityManager.enableUltraHighQualityMode(),
                        this.setupZoomRenderTarget(),
                        e())  
                }
                .bind(this))

        } 
    }


    activateTiledPano(pano, size, i) { 
        
        i && this.clearAllQueuedUploads();
        for (var n = 0; n < TileUtils.FACES_PER_PANO; n++)
            this.initTileTree(pano.id, n, this.qualityManager.getMaxPossiblePanoSize()); //得到this.tileTrees[pano.id]，arr[6]
        this.linkAllTilesAndNodes(pano);
        var r = this.getActiveRenderTargetDescriptor(pano.id),
            l = size;
            
        l > this.qualityManager.getMaxNavPanoSize() && (l = this.qualityManager.getMaxNavPanoSize())   
        if ( !r || l !== r.size) {
            r && this.deactiveDescripor(r.renderTarget) 
            r = this.activeDescripor(l)  
            if (!r) { 
                var ren = this.initTiledPano(l,  Potree.settings.disableAATarget ? false : !browser.isMobile()  ); //有的老设备如果抗锯齿打开场景时要多花五秒
                r = this.initDescriptor(ren.width);
                r.renderTarget = ren;
            }
            r.pano = pano;
            this.resetPanoDescriptor(pano.id);
            this.resetPanoLODDescriptors(pano.id);
            this.resetRenderStatus(pano.id, !0, !0);       
        }
        this.setActiveRenderTargetDescriptor(pano.id, r);
        var h = i ? 0 : 1;
        
        this.updateActivePanos(pano, h) 
        
        //console.log(`index:${this.viewer.index} ${r.renderTarget.texture.id} ${pano.id}`)    
        
        return r.renderTarget
            
    }

    deactivateTiledPano(pano) {
        var t = this.getActiveRenderTargetDescriptor(pano.id);
        if(this.isRenderTargetDescriptorValid(t)){
            this.deactiveDescripor(t.renderTarget)
            this.setActiveRenderTargetDescriptor(pano.id, null);
        }
        var i = this.getUploadQueueForPano(pano.id);
        this.clearUploadQueue(i)
        this.updateActivePanos()
        viewer.cancelLoad(pano)//add
    }


    getActivePanoCount() {
        return this.activePanos.length
    }

    resetRenderStatus(e, t, i, n) {
        var r = null;
        n && (r = TileTree.getLevelCountForSize(TileUtils.TILE_SIZE, n) + 1);
        for (var o = function (e, n, r, o) {
                i && (n.tile.zoomUploaded = !1),
                    t && (n.tile.uploaded = !1)
            }, a = 0; a < TileUtils.FACES_PER_PANO; a++) {
            var s = this.getTileTree(e, a);
            s.breadthFirst({
                callback: o.bind(this, a),
                minLevel: r
            })
        }
    }

    copyBaseRenderStatusToZoomed(e) {
        for (var t = TileTree.getLevelCountForSize(TileUtils.TILE_SIZE, this.qualityManager.getMaxNavPanoSize()), i = function (e, t, i, n) {
                t.tile.zoomUploaded = t.tile.uploaded,
                    t.zoomCovered = t.covered
            }, n = 0; n < TileUtils.FACES_PER_PANO; n++) {
            var r = this.getTileTree(e, n);
            r.breadthFirst({
                callback: i.bind(this, n),
                maxLevel: t
            })
        }
    }


    isRenderTargetDescriptorValid(e) {
        return e && e.renderTarget
    }

    isPanoActive(e) {
        var t = this.getActiveRenderTargetDescriptor(e);
        return this.isRenderTargetDescriptorValid(t)
    }

    isPanoZoomed(e) {
        return this.zoomingActive && this.zoomPanoId === e
    }

    initTileTree(e, t, i) {
        var n = this.tileTrees[e];
        n || (n = [],
            this.tileTrees[e] = n);
        var r = n[t];
        if (!r) {
            var o = TileTree.getLevelCountForSize(TileUtils.TILE_SIZE, i);
            r = new TileTree(TileUtils.TILE_SIZE, o),
                n[t] = r
        }
    }

    getTileTree(e, t) {
        var i = this.tileTrees[e];
        if (!i)
            console.error("PanoRenderer.getTileTree() -> Tree array not yet initialized!");
        var n = i[t];
        if (!n)
            console.error("PanoRenderer.getTileTree() -> Tree not yet initialized!");
        return n
    }
    
    /*
     * 创建tile的renderTarget, 包括pano.tiledPanoRenderTarget和zoomRenderTarget
     * @param {number} size 当前的panoSize,每个面的分辨率
     */
    
    initTiledPano(size, ifNormalFilter) {//创建 RenderTargetCube
        var renderer = this.viewer.renderer
        var renderTarget, texture;
            renderTarget = new THREE.WebGLCubeRenderTarget(size,{ //THREE.WebGLRenderTargetCube(size, size, {
                stencilBuffer: !1
            }) 
            texture = new THREE.CubeTexture([]);
            texture.image = [null, null, null, null, null, null] 
        texture.flipY = !0, 
        texture.format = THREE.RGBAFormat
        
        ifNormalFilter ? (texture.generateMipmaps = !0,
        texture.magFilter = THREE.LinearFilter,
        texture.minFilter = THREE.LinearMipMapLinearFilter) 
        :  (texture.generateMipmaps = !1,
        texture.magFilter = THREE.LinearFilter,  //LinearFilter更清晰，但锯齿噪点严重，相当于锐化，其实失真了。对于条纹状的画面移动镜头时锯齿明显 眩晕
        texture.minFilter = THREE.LinearFilter)   
        
        //平时还是直接用LinearMipMapLinearFilter，其实并非不清晰，只是没有加锐化，像加了层柔光和抗锯齿，观感更好。放大后使用LinearFilter
        // 如果抗锯齿的话，采用mipmap，会增加一倍的存储消耗。原版本都是不抗锯齿的。但是抗锯齿效果更柔和
        
        
        renderTarget.texture = texture //居然漏了一句，2022.10.9补
        renderer.setRenderTarget(renderTarget);
        renderer.setRenderTarget(null);
        var o = renderer.properties.get(texture); 
        o.__image__webglTextureCube = o.__webglTexture;       
        //window.tex[r.id] = {texture:r,  index:this.viewer.index } 
         
  
        return renderTarget

    }

    getUploadQueueForPano(e) {
        var t = this.uploadQueues[e];
        return t || (t = [],
                this.uploadQueues[e] = t),
            t
    }

    isTileUploaded(e) {
        return this.isPanoZoomed(e.panoId) ? e.zoomUploaded : e.uploaded
    }

    setUploaded(e, t) {
        this.isPanoZoomed(e.panoId) ? e.zoomUploaded = t : e.uploaded = t
    }

    queueTileUpload(e, t, i) {
        var n = this.getActiveRenderTargetDescriptor(e.panoId); 
    
        if (this.isRenderTargetDescriptorValid(n) && e.downloaded && !this.isTileUploaded(e) && (!e.uploadQueued || i) 
            && (!(e.panoSize > this.qualityManager.getMaxNavPanoSize()) || this.zoomingActive &&  viewer.images360.getPano(e.panoId).tileRes != '2k')) {
 
            
            var r = this.getUploadQueueForPano(e.panoId);
            //console.log(window.sceneName, 'queueTileUpload: ', e.panoId, e.tileIndex,   i)
            if(i){
                //console.log('512下载好了直接uploadTile')
                this.uploadTile(e, !1)//提交后该tile直接loaded了，无需等待
            }else{
                if(this.shoulPushToFrontOfQueue(e)){//如果是512的优先
                    this.forceQueue.push(e)
                }else{
                    if(t && this.direction){
                        TilePrioritizer.insertSortedPanoTile(r, e, n.pano, this.direction) 
                    }else r.push(e) 
                }
                e.uploadQueued = !0 
                this.uploadInterval || this.uploadIntervalCancelled || this.refreshUploadInterval(0)
            }
             
        }
    }

    shoulPushToFrontOfQueue(e) {
        return 0 === TileTree.getLevelCountForSize(TileUtils.TILE_SIZE, e.panoSize)
    }

    getTopUploadQueue() {
        for (var e = null, t = null, i = S.Base; i <= S.Remaining; i++)
            for (var n = 0; n < this.activePanos.length; n++)
                if (e = this.activePanos[n],
                    t = this.getUploadQueueForPano(e.id),
                    t.length > 0)
                    switch (i) {
                        case S.Base:
                            if (0 === t[0].level)
                                return t;
                            break;
                        case S.Remaining:
                            return t
                    }
        return null
    }


    peekNextFromUploadQueue() {
        if (this.forceQueue.length > 0)
            return this.forceQueue[0];
        var e = this.getTopUploadQueue();
        return e && e.length > 0 ? e[0] : null
    }

    clearAllQueuedUploads() {
        this.clearAllUploadQueues(null, 0)
    }

    clearAllQueuedUploadsForPano(e) {
        this.clearAllUploadQueues(e, 0)
    }

    clearAllUploadQueues(e, t) {
        if (e)
            this.clearUploadQueue(this.getUploadQueueForPano(e), t),
            this.clearUploadQueue(this.forceQueue, t, e);
        else {
            for (var i = 0; i < this.activePanos.length; i++) {
                var n = this.activePanos[i];
                this.clearUploadQueue(this.getUploadQueueForPano(n.id), t)
            }
            this.clearUploadQueue(this.forceQueue, t)
        }
    }

    clearUploadQueue(e, t, i) {
        void 0 !== t && null !== t || (t = 0);
        for (var n = 0; n < e.length;) {
            var r = e[n];
            (!i || i && i === r.tile.panoId) && r.level >= t ? (r.uploadQueued = !1,
                e.splice(n, 1)) : n++
        }
        //若报错， r.tile.panoId改为 r.panoId
    }

        
    updateUploadQueue(maxNPF,maxPF/* e, t */) {//参数是 maxNonBaseUploadsPerFrame and maxBaseUploadsPerFrame， 优先上传512
        //maxNPF || (maxNPF = 1);
        for (var i = 0, n = 0;;) {
            //let old = this.forceQueue.slice(0)
           
            if (n >= maxPF || i >= maxNPF)
                break;
            var r = this.getNextFromUploadQueue();
            if (!r)
                break;
            //r.panoSize <2048 && console.log('panoId', r.panoId, 'panoSize', r.panoSize , old)
            0 !== r.level ? i++ : n++
            if (!(r.panoSize > this.qualityManager.getMaxNavPanoSize()) || this.zoomingActive) {
                var o = this.getActiveRenderTargetDescriptor(r.panoId);
                this.isRenderTargetDescriptorValid(o) && this.uploadTile(r, r.forceUpload)
            }
        }
    }

    updateDirection(e) {
        if (e = e || this.direction) { 
            this.direction = e;                   
            for (var t = 0; t < this.activePanos.length; t++) {
                var i = this.activePanos[t],
                    n = this.getUploadQueueForPano(i.id);
                TilePrioritizer.sortPanoTiles(n, i, this.direction)
            }
        }
    }

   

    anyUploaded(e) {
        if (!e)
            return !1;
        if (e.tile && this.isTileUploaded(e.tile))
            return !0;
        if (e.children)
            for (var t = 0; t < e.children.length; t++) {
                var i = e.children[t];
                if (this.anyUploaded(i))
                    return !0
            }
        return !1
    }

    setNodeCovered(e, t) {
        this.isPanoZoomed(e.tile.panoId) ? e.zoomCovered = t : e.covered = t
    }

    isNodeCovered(e) {
        return !!e && (this.isPanoZoomed(e.tile.panoId) ? e.zoomCovered : e.covered)
    }

    addCoverageForNode(e) {
        if (this.setNodeCovered(e, !0),
            e.parent && e.covered) {
            var t = e.parent;
            this.nodeSubcovered(t) && this.addCoverageForNode(t, !0)
        }
    }

    calcFullCoverage(e) {
        var t = !1;
        if (e.children)
            for (var i = 0; i < e.children.length; i++) {
                var n = e.children[i];
                t = t || this.calcFullCoverage(n)
            }
        e.covered = e.tile.uploaded || t
    }

    nodeSubcovered(e) {
        if (!e.children)
            return !1;
        for (var t = 0; t < e.children.length; t++)
            if (!e.children[t] || !this.isNodeCovered(e.children[t]))
                return !1;
        return !0
    }

    resetPanoDescriptor(e) {
        this.getPanoDescriptor(e)
    }

    getPanoDescriptor(e) {
        var t = this.panoDescriptors[e];
        return t || (t = {},
                this.panoDescriptors[e] = t),
            t
    }

    resetPanoLODDescriptors(e) {
        var t = this.getPanoLODDescriptors(e);
        for (var i in t)
            if (t.hasOwnProperty(i)) {
                var n = t[i];
                n.uploadCount = 0,
                n.uploadAttempts = 0  
                n.uploaded = [] 
            }
    }

    getPanoLODDescriptor(e, t) {
        var i = this.getPanoLODDescriptors(e),
            n = i[t];
        return n || (n = {
                    uploadCount: 0,
                    uploadAttempts: 0, 
                    uploaded:[],//add
                },
                i[t] = n),
            n
    }

    getPanoLODDescriptors(e) {
        var t = this.panoLODDescriptors[e];
        return t || (t = {},
                this.panoLODDescriptors[e] = t),
            t
    }

    onTileDownloaded(o) {
        var e = o.desc
        var t = TileTree.getLevelCountForSize(TileUtils.TILE_SIZE, e.panoSize),
            i = this.getTileDirectoryEntry(e.panoId, e.face, t, e.faceTileIndex);
        i.downloaded = !0;
        i.image = e.image;
        i.panoSize = e.panoSize;
        i.tileX = e.tileX;
        i.tileY = e.tileY;
        i.totalTiles = e.totalTiles;
        i.tileIndex = e.tileIndex;
        i.faceTileIndex = e.faceTileIndex;
        i.face = e.face;
        i.cubeFace = TileUtils.mapFaceToCubemapFace(e.face);
        i.panoId = e.panoId;
        i.tileSize = e.tileSize;
        i.direction = (new THREE.Vector3).copy(e.direction);
        i.node = null;
        i.level = TileTree.getLevelCountForSize(TileUtils.TILE_SIZE, i.panoSize);
        if (this.isPanoActive(i.panoId)) { 
            var n = this.getTileTree(i.panoId, i.face);
            var r = n.getSubNode(i.panoSize, i.tileX, i.tileY);
            this.linkTileAndNode(i, r);
            this.queueTileUpload(i, !0);
        }
    }

    getTileDirectoryEntry(panoId, t, i, n) {
        var r = this.tileDirectory[panoId];
        r || (r = {}, this.tileDirectory[panoId] = r);
        var o = 16384 * t + 1024 * i + n,       //t:4096级别   
            a = r[o];
        return a || (a = {
                    downloaded: !1,
                    uploaded: !1,
                    zoomUploaded: !1
                },
                r[o] = a),
            a._key = panoId + ":" + t + ":" + i + ":" + n,//panoId : face : level : faceTileIndex
            a._tileKey = o,
            a
    }

    setZoomingActive(active, pano, i) {//设置当前正在zoom的pano
        this.zoomPanoRenderingDisabled || active === this.zoomingActive && this.zoomPanoId === pano.id || (this.zoomingActive = active,
            this.zoomPanoId = pano.id,
            this.zoomingActive && (this.zoomPanoId !== pano.id || i) && this.updateZoomedPanoFromBase(pano))
    }

    updateZoomedPanoFromBase(pano) {//因更换pano所以将pano的rendertarget渲染到panoRenderer的zoomRenderTarget上
        if (!this.zoomPanoRenderingDisabled) {
            var t = this.getActiveRenderTargetDescriptor(pano.id);
            if (t && t.renderTarget ) {
                if(this.zoomRenderTarget){
                    var i = Math.min(this.qualityManager.maxRenderTargetSize, this.qualityManager.getMaxZoomPanoSize()), //change
                        n = t.renderTarget,
                        r = t.size;
                    this.copyCubeMap(n.texture, this.zoomRenderTarget, r, r, i, i);
                }
                this.copyBaseRenderStatusToZoomed(pano.id)
            } 
        }
    }
    
     
    add(e) {
        this.M.push(e)
    }

    initDescriptor(size) {
        var t = createDescriptor();
        t.inUse = !0 
        t.size = size 
        this.add(t) 
        return   t
    }

    activeDescripor(e) {
        for (var t = 0; t < this.M.length; t++) {
            var i = this.M[t];
            if (!i.inUse && i.size === e){
                i.inUse = !0  
               return  i
            }
        }
        return null
    }

    deactiveDescripor(e) { 
        for (var t = 0; t < this.M.length; t++) {
            var i = this.M[t];
            if (i.renderTarget === e){
                i.inUse = !1 
                return !0
            }
        }
        return !1
    } 
    
    enableHighQuality(e){//xzw add  如果最多只要2k图的话enableUltraHighQualityMode替换成这个
        if (!this.qualityManager.highQualityModeStarted) {
            this.setupZoomRenderTarget()
            e()  
            //this.qualityManager.updateHighResolutionSettings(e)////////?
            this.qualityManager.highQualityModeStarted = true
        }
    } 
    
    
    linkTileAndNode(e, t) {
        t.tile = e,
            e.node = t
    }

    linkAllTilesAndNodes(e) {
        var t = function (t, i, n, r, o) {
            var a = this.getTileDirectoryEntry(e.id, i, r, o);
            this.linkTileAndNode(a, n)
        }
        for (var i = 0; i < TileUtils.FACES_PER_PANO; i++) {
            var n = this.getTileTree(e.id, i);
            n.breadthFirst({
                callback: t.bind(this, n, i)
            })
        }
    }
    
    //--------------sceneRenderer
    
    initSizedTexture2D(e, t, i) {
        var renderer = this.viewer.renderer,
            o = renderer.getContext(),
            a = renderer.state,
            s = new THREE.Texture(null);
        s.flipY = !1,
            i !== !0 && (i = !1),
            s.generateMipmaps = i;
        var l = renderer.paramThreeToGL(s.format),
            c = renderer.paramThreeToGL(s.type),
            h = renderer.properties.get(s),
            u = o.createTexture();
        a.bindTexture(o.TEXTURE_2D, u),
            o.pixelStorei(o.UNPACK_FLIP_Y_WEBGL, s.flipY),
            o.texImage2D(o.TEXTURE_2D, 0, l, e, e, 0, l, c, null),
            s.wrapS = t,
            s.wrapT = t;
        var d = renderer.paramThreeToGL(t);
        return o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, d),
            o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, d),
            i ? (s.magFilter = THREE.LinearFilter,
                s.minFilter = THREE.LinearMipMapLinearFilter,
                o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR),
                o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR_MIPMAP_NEAREST),
                o.generateMipmap(o.TEXTURE_2D)) : (s.magFilter = THREE.LinearFilter,
                s.minFilter = THREE.LinearFilter,
                o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR),
                o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR)),
            a.bindTexture(o.TEXTURE_2D, null),
            h.__webglTexture = u,
            s
    }

    deallocateCubeTexture(e) {
        var t = this.viewer.renderer,
            i = t.getContext(),
            renderer = t.properties.get(e);
        i.deleteTexture(renderer.__image__webglTextureCube)
    }

  
    uploadTexture2D(img, tex, startX, startY, width, height) {
        var renderer = this.viewer.renderer,
            gl = renderer.getContext(),
            webglState = renderer.state,
            c = renderer.properties.get(tex);
        webglState.bindTexture(gl.TEXTURE_2D, c.__webglTexture),
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, tex.flipY),
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, tex.premultiplyAlpha),
            gl.pixelStorei(gl.UNPACK_ALIGNMENT, tex.unpackAlignment),
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, renderer.paramThreeToGL(tex.wrapS)),
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, renderer.paramThreeToGL(tex.wrapT)),
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, renderer.paramThreeToGL(tex.magFilter)),
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, renderer.paramThreeToGL(tex.minFilter)),
            gl.texSubImage2D(gl.TEXTURE_2D, 0, startX, startY, gl.RGBA, gl.UNSIGNED_BYTE, img),
            tex.generateMipmaps && gl.generateMipmap(gl.TEXTURE_2D),
            webglState.bindTexture(gl.TEXTURE_2D, null)

    }

    getCubeOrientationForCubeFace(e, t) {
        switch (e) {
            case GLCubeFaces.GL_TEXTURE_CUBE_MAP_POSITIVE_X:
                t.set(0, -Math.PI / 2, 0);
                break;
            case GLCubeFaces.GL_TEXTURE_CUBE_MAP_NEGATIVE_X:
                t.set(0, Math.PI / 2, 0);
                break;
            case GLCubeFaces.GL_TEXTURE_CUBE_MAP_POSITIVE_Y:
                t.set(Math.PI / 2, Math.PI, 0);
                break;
            case GLCubeFaces.GL_TEXTURE_CUBE_MAP_NEGATIVE_Y:
                t.set(-Math.PI / 2, Math.PI, 0);
                break;
            case GLCubeFaces.GL_TEXTURE_CUBE_MAP_POSITIVE_Z:
                t.set(0, -Math.PI, 0);
                break;
            case GLCubeFaces.GL_TEXTURE_CUBE_MAP_NEGATIVE_Z:
                t.set(0, 0, 0)
        }
    }
    
    //dispose所有cubeRenderTarget
    disposeIdelTargets() {
        let disposeCount = 0
        for (var t = 0; t < this.M.length; t++) {
            var i = this.M[t]
            if (!i.inUse) {
                disposeCount++
                i.renderTarget.dispose()
            }
        }
        //console.log('disposeIdelTargets ', disposeCount, 'of', this.M.length)
    }
}












PanoRenderer.prototype.setupZoomRenderTarget = function(){
    var targets = {};
    return function(){
        if(this.qualityManager.maxRenderTargetSize == 2048 && this.qualityManager.getMaxNavPanoSize()==2048)return; //不使用zoomTarget 直接用pano的tiledPanoRenderTarget，防崩溃
        
         
        if (this.qualityManager.getMaxZoomPanoSize() >= this.qualityManager.getMaxNavPanoSize()  ) {
         //部分手机2k时copyCubeMap会重载 ， 所以如果没有超出当前分辨率，就不使用zoomRenderTarget。但在微信依旧会重载，只是优化了些，safari几乎不会。
            if (this.zoomRenderTarget && this.zoomRenderTarget.width === this.qualityManager.getMaxZoomPanoSize())
                return;
            var e = this.zoomRenderTarget;
            
            
            var size = this.qualityManager.getMaxZoomPanoSize()
            if(size > this.qualityManager.maxRenderTargetSize){ 
                return 
            } 
            
            if(targets[size]){
                this.zoomRenderTarget = targets[size]
            }else{
                this.zoomRenderTarget = this.initTiledPano(size, false  ) //放大后不使用抗锯齿，否则消
                targets[size] = this.zoomRenderTarget
            }
            
            if (e) {//将旧的zoomRenderTarget渲染到新zoomRenderTarget上
                var t = e.width,
                    i = this.zoomRenderTarget.width; 
                this.copyCubeMap(e.texture, this.zoomRenderTarget, t, t, i, i),
                    e.texture.dispose(),
                    e.texture.loaded = !1,
                    e.texture.version = 0,
                    this.deallocateCubeTexture(e.texture),
                    e.texture = null
            }
            this.zoomPanoRenderingDisabled = !1
        } else
        this.zoomPanoRenderingDisabled = !0
    }
}()
PanoRenderer.prototype.updateActivePanos = function () {
    var e = [];
    return function (t, i) {
        e.length = 0;
        for (var n = 0; n < this.activePanos.length; n++) {
            t && e.length === i && e.push(t);
            var r = this.activePanos[n],
                o = this.getActiveRenderTargetDescriptor(r.id);
            t && r.id === t.id || !this.isRenderTargetDescriptorValid(o) || e.push(r)
        }
        t && i >= e.length && e.push(t),
            this.activePanos.length = 0,
            this.activePanos.push.apply(this.activePanos, e)
    }
}()
PanoRenderer.prototype.renderPanoTiles = function () {
    var e = [];
    return function (panoId, i, n, r) {
        this.zoomRenderTarget && this.zoomRenderTarget.width === this.qualityManager.getMaxZoomPanoSize() || this.zoomPanoRenderingDisabled || this.setupZoomRenderTarget(),//如果ZoomRenderTarget大小需要变动就重新创建
            i =  i || this.direction ||  Vectors.FORWARD; // [{1:Vectors.FORWARD}]?
        var o = this.getActiveRenderTargetDescriptor(panoId);
        if (!this.isRenderTargetDescriptorValid(o))
            console.error("PanoRenderer.renderPanoTiles() -> Cannot render to a pano that is not activated.");
        for (var a = 0; a < TileUtils.FACES_PER_PANO; a++) {
            var s = this.getTileTree(panoId, a);
            e.length = 0 
            s.breadthFirst({//获取该面所有node  85个 = 1+4+16+64
                saveVisited: e
            });
            for (var l = 0; l < e.length; l++) {
                var c = e[l];
                this.queueTileUpload(c.tile, !1, r || 0 === l && n)// 第0个是512的，会直接uploadTile 
            }
        }
        this.updateDirection(i)
    }
}()
PanoRenderer.prototype.getNextFromUploadQueue = function () {
    var e = function (e) {
        var t = e.shift();
        return t.uploadQueued = !1,
            t
    };
    return function () {
        if (this.forceQueue.length > 0)
            return e(this.forceQueue);
        var t = this.getTopUploadQueue();
        return t && t.length > 0 ? e(t) : null
    }
}()


/* PanoRenderer.prototype.refreshUploadInterval = function () {
    var e = null;
    return function (t) {
        this.uploadIntervalCancelled || (e || (e = upload.bind(this)),
            null !== t && void 0 !== t || (t = w),
            b || (t = _),
            this.uploadInterval = window.setTimeout(e, t),
            this.uploadIntervalDelay = t)
    }
}()  

PanoRenderer.prototype.update = function () {
    var e = performance.now(),
        t = 0;
    return function () {
        this.uploadIntervalCancelled = !0;
        window.clearTimeout(this.uploadInterval);
        this.uploadInterval = null;
        var i = performance.now() - e;
        //!(i > w || 0 === t) || !this.overlayTilesLoaded && this.usingTileOverlay || (this.updateUploadQueue(this.maxNonBaseUploadsPerFrame, this.maxBaseUploadsPerFrame),
        //e = performance.now()),
        if (!(i > w || 0 === t) || !this.overlayTilesLoaded && this.usingTileOverlay) {} else {
            this.updateUploadQueue(this.maxNonBaseUploadsPerFrame, this.maxBaseUploadsPerFrame);
            e = performance.now();
        }
        t++;
    }
}() */






PanoRenderer.prototype.update = function () {
    //this.uploadIntervalCancelled = true ; //不使用setTimeout,而是在sceneRenderer每帧都update
    
    if(viewer.images360.latestRequestMode == 'showPanos'){  
        let maxNonBaseUploadsPerFrame = viewer.lastFrameChanged ? Common.getBestCount('maxStandard', 0,  2,  1,  10   /*  ,true */    ) : 2    // 这是每帧uploadTile非512的瓦片tex的数量。 手机在前进时可能会总是0，直到到漫游点后为2
        let maxBaseUploadsPerFrame = viewer.lastFrameChanged ? Common.getBestCount('maxBase',1,6,  1, 14 /* ,true */ ) : 6 //this.maxBaseUploadsPerFrame //原先6. 但持续前进过程中会请求加载下一个漫游图，一次加6张会卡的。
         
        this.updateUploadQueue(maxNonBaseUploadsPerFrame, maxBaseUploadsPerFrame) 
        
        //注：静止时看不出卡顿所以全速加载
    }
} 



/* function upload() { 
    if (!this.uploadIntervalCancelled) {
        if (this.overlayTilesLoaded || !this.usingTileOverlay) {
            b = !0   
            let maxNonBaseUploadsPerFrame = viewer.mainViewport.view.isFlying() ? 1 : this.maxNonBaseUploadsPerFrame //原先2。这是每帧uploadTile非512的瓦片tex的数量。之前的2太卡了，降为1。（检测卡顿方法：在一个pano点旋转至所有2048的tile都加载完，然后之后到这个点看看卡不卡。因为该点tiles都下载完了所以会在飞过来时陆续都加载，所以容易卡）
            this.updateUploadQueue(maxNonBaseUploadsPerFrame, this.maxBaseUploadsPerFrame) 
            let time = viewer.mainViewport.view.isFlying() ? 60 : w  //add 飞行有时候会卡，增长间隔 
            this.peekNextFromUploadQueue() ? this.refreshUploadInterval(time) : this.uploadInterval = null  //定时下一次更新
        } else {
            this.refreshUploadInterval(this.uploadIntervalDelay)
        }
    }
} */




PanoRenderer.prototype.uploadTile = function () {//重写
    var collection = {},
        overlayStyle = config.tiling.overlayStyle;
        
    var failHistory = {};    
        
    return function (info, n) {
        
        var id = info.panoId,
            img = info.image,
            tileSize = info.tileSize,
            panoSize = info.panoSize,
            tileIndex = info.tileIndex,
            totalTiles = info.totalTiles, 
            tileX = info.tileX,
            tileY = info.tileY,
            p = !0,
            g = !1,
            ignore = false, //add   
            LodDescripor = (this.getPanoDescriptor(id), this.getPanoLODDescriptor(id, panoSize)),
            activeDescripor = this.getActiveRenderTargetDescriptor(id),
            renderTarget = activeDescripor.renderTarget,
            size = activeDescripor.size;//当前要渲染的面的分辨率，也就是MaxNavPanoSize
            
            
        if (this.isPanoZoomed(id) && this.zoomRenderTarget) {
            renderTarget = this.zoomRenderTarget;
            size =  this.zoomRenderTarget.width   //this.qualityManager.getMaxZoomPanoSize(); //放大后可能2048或4096
        } 
        //console.log(window.sceneName, 'uploadTile ', id, tileIndex)
        
        
        let done = ()=>{ 
            if(!LodDescripor.uploaded.includes(tileIndex)){//已经upload过（本来这时候直接返回，但发现缩放后这不会归零，导致清晰度不更新，所以还是redraw且emit吧）
                //console.log('try to reupload and return',tileIndex) 
                LodDescripor.uploaded.push(tileIndex)
                LodDescripor.uploadCount++;
            }   
            this.dispatchEvent({type:PanoRendererEvents.TileRenderSuccess, id, panoSize, tileIndex, totalTiles});
            LodDescripor.uploadCount === totalTiles && this.dispatchEvent({type:PanoRendererEvents.PanoRenderComplete, id, panoSize, totalTiles, updateFullComplete:true});
            this.setUploaded(info, !0);
            this.addCoverageForNode(info.node);
        }
        
        
        
        {//已经uploadTile过了不再uploadTile
            if(!this.isRenderTargetDescriptorValid(activeDescripor)){
                p = !1; g = !1
            } 
            if(!n){
                this.anyUploaded(info.node) && (p = !1, g = !0,ignore = true  ) //包括子集也uploadTile了
                this.isTileUploaded(info) && (p = !1, g = !1,ignore = true ) //当前tile uploadTile了 
            }
        }
        
        
        if (p) {
             
            /*if(failHistory[id+':'+ panoSize+ ':' +tileIndex]){
                console.log('uploadTile retry',id, panoSize, tileIndex)
            }   
            console.log('uploadTile 成功', id, panoSize, tileIndex) */

            var C = tileX * tileSize,
                I = tileY * tileSize,
                E = tileSize / panoSize * size, // tile在renderTarget上渲染出的宽度
                b = C / panoSize * size,  // tile在renderTarget上渲染的startX
                w = I / panoSize * size;  // tile在renderTarget上渲染的startY
             
            if(panoSize > this.qualityManager.maxRenderTargetSize ){ //4096 改
                /* var tex = this.initSizedTexture2D(tileSize, THREE.ClampToEdgeWrapping);
                var loaded = this.viewer.images360.isHighMapLoaded(info.cubeFace, tileX,tileY)   */ 
                this.viewer.images360.getHighImage(img, info.cubeFace, tileX, tileY)                
            }else{  
                collection[tileSize] || (collection[tileSize] = this.initSizedTexture2D(tileSize, THREE.ClampToEdgeWrapping));
                var tex = collection[tileSize];
             
                this.uploadTexture2D(img, tex, 0, 0, tileSize, tileSize);//只替换tex对应的img,不新建
                  
                if(panoSize > this.qualityManager.maxRenderTargetSize){
                    loaded || this.viewer.images360.updateHighMap(tex, info.cubeFace, tileX,tileY) 
                }else{ 
                    if (1 === overlayStyle || 2 === overlayStyle) {
                        var T = 1 === overlayStyle ? this.overlayTilesBasic : this.overlayTilesEnhanced;
                        this.renderToCubeMap(tex, renderTarget, tileSize, tileSize, 0, 0, tileSize, tileSize, b, w, E, E, info.cubeFace);
                        this.renderToCubeMap(T[panoSize], renderTarget, tileSize, tileSize, 0, 0, tileSize, tileSize, b, w, E, E, info.cubeFace, THREE.NormalBlending, !0, .5);
                    } else { 
                        this.renderToCubeMap(tex, renderTarget, tileSize, tileSize, 0, 0, tileSize, tileSize, b, w, E, E, info.cubeFace);
                    }
                }
            }
            done()
           
        }else if(ignore){ 
            //console.log('finish because anyUploaded',id,panoSize,tileIndex)
            done() //改： 如果因为这部分更高清的贴图已加载所以才不绘制的话，直接完成
            
        }else{
            //console.log('uploadTile  失败', id, panoSize, tileIndex)
            if(panoSize == 512){
                //console.log("!!!!!!!!!!!!!")
            } 
            
            failHistory[id+':'+ panoSize+ ':' +tileIndex] = true;   
            this.setUploaded(info, !1); 
        }





        info.uploadAttempted || (LodDescripor.uploadAttempts++, this.dispatchEvent({type:PanoRendererEvents.TileUploadAttempted, id, panoSize, tileIndex, totalTiles})),
        info.uploadAttempted = !0;
        LodDescripor.uploadAttempts === totalTiles && this.dispatchEvent({type:PanoRendererEvents.UploadAttemptedForAllTiles, id, panoSize, totalTiles});
        return g;
    }
}()








/* 
    注：tileY的方向同UV，从下到上
    renderToCubeMap里的画布or镜头的xy范围是-0.5到0.5
 */
 
 
PanoRenderer.prototype.renderToCubeMap = function() { 
    var inited = !1,
        scene = null,
        camera = null,
        material = null,
        geo = null,
        plane = null,
        l = 1;
    return function(texture, renderTarget, tileWidth, tileHeight, startXinTile, startYinTile, widthinTile, heightinTile, startX, startY, width, height, cubeFace, E, b, w) {
           
          
        var renderer =  this.viewer.renderer; 
        
        inited || (camera = new THREE.OrthographicCamera(l / -2, l / 2, l / 2, l / -2, -200, 200),
            camera.position.z = 150,
            scene = new THREE.Scene,
            scene.add(camera),  
            material = new BasicMaterial({  depthWrite: !1,  depthTest: !1, side: 0,}),  
            geo = new THREE.PlaneBufferGeometry(l, l),
            plane = new THREE.Mesh(geo, material),
            plane.position.z = 0,
            scene.add(plane),
            inited = !0);
        var uv = geo.getAttribute("uv");
            uv.setDynamic(!0),  //setUsage
            uv.needsUpdate = !0;
         
        var uvArr = uv.array,
            S = startXinTile / tileWidth,    //uv这几个值基本是固定的startXinTile:0,startYinTile:0,widthinTile:512,widthinTile:512,tileWidth:512,tileHeight:512  也就是说uv不会变、每张tile的有效范围是100%
            M = startYinTile / tileHeight,
            R = widthinTile / tileWidth,
            P = heightinTile / tileHeight;
            uvArr[0] = S,
            uvArr[1] = M + P,
            uvArr[2] = S + R,
            uvArr[3] = M + P,
            uvArr[4] = S,
            uvArr[5] = M,
            uvArr[6] = S + R,
            uvArr[7] = M;
            
            
        //修改posistion，使该plane只占据需要绘制的部分。类似拼图。    
        //startX startY width height 都是在画布上的大小，比如画布大小为2048*2048，此tile为16分之一，tileX是1，tileY是1，则startX=2048/4,startY=2048/4
        
        
        var pos = geo.getAttribute("position");
            pos.setDynamic(!0),
            pos.needsUpdate = !0;
        var posArr = pos.array,
            D = startX / renderTarget.width - l / 2 // 起始x
            ,
            N = startY / renderTarget.height - l / 2 // 起始y
            ,
            B = width / renderTarget.width // 宽
            ,
            F = height / renderTarget.height; // 高
            posArr[0] = D,
            posArr[1] = N + F,
            posArr[3] = D + B,
            posArr[4] = N + F,
            posArr[6] = D,
            posArr[7] = N,
            posArr[9] = D + B,
            posArr[10] = N;
            
        //renderer.properties.get(scene); 
        material.map = texture//material.uniforms.map.value = texture;
        material.blending = E || THREE.NoBlending,
        material.transparent = !!b 
        
        void 0 !== w && null !== w || (w = 1),
        material.uniforms.opacity.value = w,
     //   material.needUpdate = !0  
        //renderTarget.activeCubeFace = cubeFace, //0-5 应该是指定渲染h中的面  失效
        /* renderer.setScissorTest(!0)  
        //指定绘制区域，类似遮罩（相对于屏幕）
        renderer.setScissor(startX,startY,width,height) //加上这个会不会快一些，尤其是spherical
        //指定绘制视口位置和大小（相对于屏幕）
         */
        renderTarget.viewport.set(0, 0, renderTarget.width, renderTarget.height);


        var V = renderer.autoClear;
        var oldTarget = renderer.getRenderTarget();
        renderer.autoClear = !1
        
        
         
         
        
        renderer.setRenderTarget(renderTarget, cubeFace);
        renderer.render(scene, camera/* , renderTarget, !1 */);  
        renderer.setRenderTarget(oldTarget)
        renderer.autoClear = V
        //renderer.setScissorTest(!1) 
        
        /* this.renderer.render(scene, camera, this.planeTargets[cubeFace], !1),//针对有的场景app第一个点图加载不成功的问题
        console.log(`图index ${cubeFace} , ${startX}, ${startY}, ${width}, ${height}`)   
        this.targetList[cubeFace]  || (this.targetList[cubeFace] = [])
        this.targetList[cubeFace].push([startX,startY,width,height])*/


        

    }
}()

/*
 * 将texture渲染到zoomRenderTarget上(目的是复制贴图到zoomRenderTarget） 
 */
PanoRenderer.prototype.copyCubeMap = function() {//将texture渲染到zoomRenderTarget上
    var inited = !1, 
        scene = null,
        camera = null,
        material = null,
        geo = null,
        mesh = null, 
        testCube = null, //add
        c = new THREE.Euler; 
        
    return function(texture, renderTarget, tWidth, tHeight, rWidth, rHeight, m, v, A) { 
    
        if(rWidth > this.qualityManager.maxRenderTargetSize) return; //add
    
        if (!inited) {
            var w = 2;
            camera = new THREE.OrthographicCamera(w / -2, w / 2, w / 2, w / -2, 0, 200),
            camera.position.set(0, 0, 0),
            scene = new THREE.Scene,
            scene.add(camera) 
            material = new THREE.ShaderMaterial({
                uniforms: {
                    tDiffuse: {
                        type: "t",
                        value: null
                    },
                    alpha: {
                        type: "f",
                        value: 1
                    }
                },
                 
                vertexShader: Shaders['copyCubeMap.vs'],  
                fragmentShader:Shaders['copyCubeMap.fs'],  
                depthWrite: !1,
                depthTest: !1,
                side: THREE.DoubleSide
            }) 
            geo = new THREE.BoxGeometry(w, w, w),
            mesh = new THREE.Mesh(geo, material),
            scene.add(mesh)
            inited = !0 
            
            
            /* testCube = mesh.clone();  
            viewer.scene.scene.add(testCube);
            Potree.Utils.setObjectLayers(testCube, 'sceneObjects') 
             */
        }
        let autoClear = this.viewer.renderer.autoClear
        let oldTarget = this.viewer.renderer.getRenderTarget();
        this.viewer.renderer.autoClear = false
        
        
        material.uniforms.tDiffuse.value = texture 
        material.blending = m || THREE.NoBlending 
        material.transparent = !!v 
        void 0 !== A && null !== A || (A = 1) 
        material.uniforms.alpha.value = A
        material.needUpdate = !0
         
        
        
        for (var C = 0; C < 6; C++){
            this.getCubeOrientationForCubeFace(C, c) 
            mesh.rotation.copy(c)   
            mesh.matrixWorldNeedsUpdate = !0 
            mesh.updateMatrixWorld()  
            renderTarget.viewport.set(0, 0, rWidth, rHeight)
            this.viewer.renderer.setRenderTarget(renderTarget, C ) //renderTarget.activeCubeFace = C//失效
            this.viewer.renderer.render(scene, camera) 
        } 
        //console.warn('copyCubeMap' + rWidth)
        this.viewer.renderer.autoClear = autoClear
        this.viewer.renderer.setRenderTarget(oldTarget)  
    }    
}()



/* 
forceQueue在tiledownloader和panorenderer都有。
forceQueue 的应该就是优先下载的吧，按理说一定要先下载完才能下载后面的在 
在panoRenderer中 uploadQueues 是候补队列 ，在tileDownloader里priorityQueue是候补队列
tiledownloader下载完成会触发tiledownloader开始uploadTile.
 */


export default PanoRenderer